export class ScrollLock {
    private _isLocked = false;

    // tslint:disable-next-line: variable-name
    private static _instance: ScrollLock;
    private bodyScrollPosition = 0;

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    get isLocked(): boolean {
        return this._isLocked;
    }

    public lock(): void {
        this.bodyScrollPosition = window.pageYOffset;
        document.body.setAttribute(
            'style',
            'overflow: hidden !important; position: fixed !important; top: -' +
            this.bodyScrollPosition +
            'px;',
        );
        this._isLocked = true;
    }

    public unlock(): void {
        document.body.removeAttribute('style');
        window.scrollTo(0, this.bodyScrollPosition);
        this._isLocked = false;
    }
}
